// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__XIif2","slide":"styles_slide__b_Kg7","bordered":"styles_bordered__0XT_4","borderless":"styles_borderless__FkaMx"};